import {
  Button,
  Component,
  InputBox,
  styleForFullExpansion,
  theme,
  useSafeCallback,
  useSafeState,
  useUnmountRef
} from '@atomica.co/components';
import { UserId } from '@atomica.co/types';
import { builder, EMPTY, Name, SLASH, Text } from '@atomica.co/utils';
import { SaveUserFacebookURLRequest } from '@atomica.co/yosemal';
import { default as React } from 'react';
import styled from 'styled-components';
import { HEADER_HEIGHT } from '../../../../../constants/common-constants';
import UserRequest from '../../../../../requests/user-request';
import InputProfileHeader from '../../../account-header/InputProfileHeader';
import { EditProfileIndex } from '../EditProfile';

interface P {
  userId: UserId | undefined;
  facebookURL: Text | undefined;
  onSave(facebookURL: Text): void;
  goTo(index: EditProfileIndex): void;
}

const InputFacebookURL: React.FC<P> = React.memo(props => {
  const { userId, facebookURL: initFacebookURL = EMPTY, onSave, goTo } = props;
  const unmountRef = useUnmountRef();
  const [disabledSaveButton, setDisabledSaveButton] = useSafeState<boolean>(unmountRef, false);
  const [facebookURLToSave, setFacebookURLToSave] = useSafeState<Name>(unmountRef, initFacebookURL);

  const saveFacebookURL = useSafeCallback(async (): Promise<void> => {
    if (!userId) return;
    setDisabledSaveButton(true);

    const dirs = facebookURLToSave.split(SLASH);
    const facebookId = !!dirs[dirs.length - 1] ? dirs[dirs.length - 1] : dirs[dirs.length - 2];

    const request = builder<SaveUserFacebookURLRequest>().userId(userId).facebookURL(facebookId).build();
    await UserRequest.saveFacebookURL(request);

    onSave(facebookId);
  }, [setDisabledSaveButton, userId, facebookURLToSave, onSave]);

  return (
    <Component style={styleForFullExpansion} className='input-facebook-url'>
      <HeaderArea>
        <InputProfileHeader label='Facebook / プロフィールのリンク' onClick={goTo} />
      </HeaderArea>

      <Body>
        <InputWrapper>
          <InputBox showCount shape='rect' text={facebookURLToSave} onChange={setFacebookURLToSave} />
        </InputWrapper>

        <ButtonArea>
          <Button type='primary' disabled={disabledSaveButton} onClick={saveFacebookURL}>
            <StyledLabel>保存</StyledLabel>
          </Button>
        </ButtonArea>
      </Body>
    </Component>
  );
});

export default InputFacebookURL;

const HeaderArea = styled.div`
  width: 100%;
  height: ${HEADER_HEIGHT}px;
`;

const Body = styled.div`
  width: 100%;
  height: calc(100% - 48px);
`;

const InputWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: ${theme.mixins.spacing * 4}px ${theme.mixins.spacing * 2}px;
`;

const ButtonArea = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
`;

const StyledLabel = styled.div`
  width: 80px;
  height: auto;
`;
